module.exports = __webpack_public_path__ + "img/SliderButton.3d2ddae0.png";